module.exports = __webpack_public_path__ + "static/img/11.eeea60a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/sp/11.png
// module id = VaqE
// module chunks = 0